import { getStore } from '../../../../../init-store';
import { setChatUserGuid } from '../../../../pages/call/features/chat';
import { getUserUid } from '../../get-user-uid';
import { getUrl } from '../../url';
import { getChatApiHost } from './helpers';
import { ChatError } from './types';

export class ChatApi {
    private headers: Record<string, string> = {};
    private omitCredentials = false;

    private async getCSRFToken(): Promise<string | undefined> {
        const data = await this.request('/csrf-token/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Application-Id': 'telemost',
            },
        });

        return data?.token;
    }

    public async getUserChatGuid(): Promise<string | undefined> {
        // FIXME: не правильно чтобы в общей библиотеке мы ходили за стором и стейтом, хорошо бы поправить
        const store = getStore();
        const chatUserGuid = store.getState().call.chat.chatUserGuid;
        if (chatUserGuid) {
            return chatUserGuid;
        }

        const headers = { ...this.headers };
        // Если нет заголовка Authorization, то авторизация идет по сессионной cookie,
        // а это требует CSRF токен
        if (!headers.Authorization) {
            const token = await this.getCSRFToken();
            headers['x-csrf-token'] = token || '';
        }

        const data = await this.request('/api/registry/api', {
            method: 'POST',
            headers: {
                ...headers,
                'Content-Type': 'application/json',
                'X-Application-Id': 'telemost',
            },
            body: JSON.stringify({ method: 'request_user', params: { bind_phone_number: false } }),
        });
        const guid = data?.data?.user?.guid;
        store.dispatch(setChatUserGuid(data?.data?.user?.guid));

        return guid;
    }

    private request(
        path: string,
        request: RequestInit = {},
        search?: string
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ): Promise<{ [key in string]: any }> {
        const url = getUrl(getChatApiHost(), path, search);

        const requestInfo: RequestInit = {
            ...request,
            credentials: this.omitCredentials ? 'omit' : 'include',
        };

        const userUid = getUserUid();
        if (userUid) {
            if (!request.headers) {
                request.headers = {};
            }

            // @ts-expect-error
            request.headers['X-Uid'] = userUid;
        }

        return fetch(url, requestInfo).then((result) => {
            if (!result.ok) {
                throw new ChatError(result.status, result.statusText);
            }
            return result.json();
        });
    }

    public setHeader(key: string, value: string) {
        this.headers[key] = value;
    }

    public setApiAuthorizationHeader(token: string) {
        this.setHeader('Authorization', `OAuth ${token}`);
    }

    public disableCredentials() {
        this.omitCredentials = true;
    }
}
